import styled from 'styled-components'

export const Root = styled.div`
  position: relative;
  width: 100%;
  z-index: ${ (props) => props.theme.zIndices.dropdown };
`

export const OptionsContainer = styled.div`
  position: absolute;
  background: white;
  width: 100%;
  border-color: ${ (props) => props.theme.colors['aok-gruen'] };
  border-width: 0 1px 1px 1px;
  border-style: solid;
  overflow-y: auto;
`
